import React from 'react';
import { ChevronDown } from 'lucide-react';

export const HeroSection = () => {
  const scrollToNext = () => {
    const nextSection = document.querySelector('#impact-stats');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="min-h-screen flex items-center justify-center grain-texture pt-24 sm:pt-32 pb-12" style={{ backgroundColor: 'var(--white-soft)' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        {/* Decorative Rule */}
        <div className="decorative-rule mb-6 sm:mb-8"></div>

        {/* Logo */}
        <div className="mb-6 sm:mb-8 flex justify-center">
          <img 
            src="/assets/lhsc-logo.png" 
            alt="The Lady Hustler Society Club - International Female Entrepreneurs & Professionals Association - Women's Economic Empowerment" 
            className="w-32 sm:w-40 md:w-48 h-auto"
            style={{ objectFit: 'contain' }}
            loading="eager"
          />
        </div>

        {/* Brand Name Lockup */}
        <div className="mb-4 sm:mb-6">
          <p className="lhsc-subheading text-[0.65rem] sm:text-xs px-2" style={{ color: 'var(--slate-grey)' }}>
            INTERNATIONAL FEMALE ENTREPRENEURS & PROFESSIONALS ASSOCIATION
          </p>
        </div>

        {/* Main Headline */}
        <h1 className="lhsc-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl mb-6 sm:mb-8 leading-tight px-2">
          WE ARE A NEW BREED OF DISRUPTORS.
        </h1>

        {/* Subheadline */}
        <p className="lhsc-subheading text-sm sm:text-base md:text-lg mb-8 sm:mb-12 leading-relaxed px-2" style={{ color: 'var(--slate-grey)' }}>
          An international association of female entrepreneurs and professionals —<br className="hidden md:block" />
          building movements, not just businesses.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-8 sm:mb-12 px-4">
          <a
            href="https://entrepreneurladyhustler.com/en/become-a-lady-hustler/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 rounded-md text-white font-semibold text-sm sm:text-base tracking-wider text-center"
            style={{ 
              backgroundColor: 'var(--mauve-rose)',
              fontFamily: 'Josefin Sans, sans-serif',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              fontWeight: 500
            }}
          >
            Become a Lady Hustler
          </a>
        </div>

        {/* Ornament */}
        <div className="ornament mb-8 sm:mb-12">+</div>

        {/* Scroll Indicator */}
        <button 
          onClick={scrollToNext}
          className="inline-flex flex-col items-center animate-bounce cursor-pointer"
          style={{ color: 'var(--mauve-rose)' }}
        >
          <ChevronDown size={32} />
        </button>
      </div>
    </section>
  );
};
